export default __webpack_public_path__ + "img/img_sarah-e8cc7ed572a957a7cb6d57df443224bc.png";